// extracted by mini-css-extract-plugin
export default {"no-match":"NoMatch_no-match__9CCw6"};